import { createContext } from "react";
// Contexto del módulo
export const GiftOrdersContext = createContext(null);
// Contexto del datagrid
export const GiftOrdersDatagridContext = createContext(null);
